import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import CustomerDetail from "containers/Common/Customer/customerDetail";
export const BtnChiTietKhachhang = ({ item }) => {
  const [showChiTietKhachHang, setShowChiTietKhachHang] = useState(false);
  const khachHangDetail = {};
  //HIỂN THỊ CHI TIẾT KHÁCH HÀNG
  const setModalChiTietKhachHangShow = (khachHangDetail) => () => {
    if (khachHangDetail)
      setShowChiTietKhachHang(!showChiTietKhachHang, khachHangDetail);
    else setShowChiTietKhachHang(!showChiTietKhachHang);
  };

  return (
    <>
      <a
        onClick={setModalChiTietKhachHangShow(item)}
        href={() => false}
        className="blue btn-link"
      >
        {item.CustomerName}
      </a>
      {showChiTietKhachHang && (
        <CustomerDetail
          show={showChiTietKhachHang}
          onHide={setModalChiTietKhachHangShow(khachHangDetail)}
          data={item}
        ></CustomerDetail>
      )}
    </>
  );
};
